import { useCurrentOrganizationId } from '@cast/infrastructure-organization';

import { useDatabaseInstancesQuery } from 'hooks/queries/dbo/useDatabaseInstancesQuery';

import { dboProtocolToLabel } from 'features/db-optimization/v2/constants';

/**
 * Returns a Map<entityId, engineLabel> derived from the DBO database-instances
 * list.  The "engine" shown in the table is the human-readable protocol label
 * (e.g. "PostgreSQL", "MySQL").
 *
 * Falls back to an empty map while loading or on error.
 */
export const useDbInstanceEngines = (): Map<string, string> => {
  const organizationId = useCurrentOrganizationId();

  const { data } = useDatabaseInstancesQuery(
    { organizationId: organizationId ?? '' },
    { enabled: !!organizationId }
  );

  const engineMap = new Map<string, string>();
  for (const instance of data?.items ?? []) {
    const id = instance.id;
    const protocol = instance.protocol;
    if (!id || !protocol) continue;
    const label = dboProtocolToLabel[protocol] ?? undefined;
    if (label) {
      engineMap.set(id, label);
    }
  }
  return engineMap;
};
